// (function() {
//     const isRTL = getComputedStyle(document.body).direction === "rtl"
//       , initScrollProducts = () => {
//         document.querySelectorAll(".section-scroll-products").forEach(section => {
//             if (section.classList.contains("scroll_initialized"))
//                 return;
//             section.classList.add("scroll_initialized");
//             const parent = section.querySelector(".scroll-products__container")
//               , child = section.querySelector(".scroll-products")
//               , innerDiv = child.querySelector(".scroll-products__products")
//               , productCard = section.querySelector(".scroll-products__item")
//               , wrapper = section.querySelector(".scroll-products__wrapper")
//               , productsCount = +child.dataset.productsCount
//               , isSingleProduct = productsCount == 1
//               , childBefore = window.getComputedStyle(child, "::before")
//               , slideHeight = parseFloat(childBefore.height)
//               , updateMinHeight = () => {
//                 if (productCard) {
//                     wrapper.style.maxHeight = `${productCard.offsetHeight}px`;
//                     let productCardHeight = productCard.offsetHeight + 96;
//                     productCardHeight < slideHeight && (productCardHeight = slideHeight),
//                     parseInt(child.style.minHeight) !== productCardHeight && (child.style.minHeight = `${productCardHeight}px`)
//                 }
//             };
//             if (updateMinHeight(),
//             !parent || !child || !innerDiv)
//                 return;
//             const handleScroll = () => {
//                 // Mobile pe scroll animation bilkul band
//                 if (window.innerWidth <= 989) {
//                     innerDiv.style.transform = "none";
//                     return;
//                 }

//                 const parentRect = parent.getBoundingClientRect()
//                   , childRect = child.getBoundingClientRect()
//                   , startScroll = parentRect.top + window.scrollY
//                   , endScroll = parentRect.bottom - childRect.height + window.scrollY
//                   , isMediumScreen = window.innerWidth < 1360
//                   , scrolled = Math.min(Math.max((window.scrollY - startScroll) / (endScroll - startScroll), 0), 1);
//                 let translateY = -50
//                   , translateX = -50;
//                 productsCount == 4
//                   ? (translateX = isMediumScreen ? 76 - 76 * scrolled : 70 - 70 * scrolled)
//                   : !isSingleProduct
//                   ? (translateX = isMediumScreen ? 67 - 67 * scrolled : 60 - 60 * scrolled)
//                   : (translateX = 0, translateY = -50 * scrolled),
//                 innerDiv.style.transform = `translate(${isRTL ? -translateX : translateX}%, ${translateY}%)`
//             }
//               , handleResize = () => {
//                 handleScroll(),
//                 updateMinHeight()
//             };
//             window.addEventListener("scroll", handleScroll),
//             window.addEventListener("resize", handleResize),
//             handleScroll()
//         })
//     };
//     initScrollProducts(),
//     document.addEventListener("shopify:section:load", () => {
//         initScrollProducts()
//     })
// })();



(function() {
    const initScrollProducts = () => {
        document.querySelectorAll(".section-scroll-products").forEach(section => {
            if (section.classList.contains("scroll_initialized"))
                return;
            section.classList.add("scroll_initialized");
            const parent = section.querySelector(".scroll-products__container")
              , child = section.querySelector(".scroll-products")
              , innerDiv = child.querySelector(".scroll-products__products")
              , productCard = section.querySelector(".scroll-products__item")
              , wrapper = section.querySelector(".scroll-products__wrapper")
              , updateMinHeight = () => {
                if (productCard) {
                    wrapper.style.maxHeight = "";
                    child.style.minHeight = "";
                }
            };
            if (updateMinHeight(),
            !parent || !child || !innerDiv)
                return;

            // Scroll animation disabled — cards always visible
            innerDiv.style.transform = "none";

            const handleResize = () => {
                innerDiv.style.transform = "none";
                updateMinHeight();
            };

            window.addEventListener("resize", handleResize);
        })
    };
    initScrollProducts();
    document.addEventListener("shopify:section:load", () => {
        initScrollProducts();
    });
})();